
import { metaDataMixin, eoRendererMixin } from '~/mixins'

export default {
  mixins: [
    metaDataMixin,
    eoRendererMixin,
  ],
  layout: 'program',
  scrollToTop: false,
  async asyncData ({ $api, $config, error, params: { program: slug } }) {
    if (slug) {
      const [
        { data: { items: programs = [] } = {} },
      ] = await Promise.all([ // Get program for this slug
        $api.programs.getOneBySlug(slug, {
          domain: $config.preprEnvironmentDomainGeneriek,
        }),
      ])
      const program = programs[0]
      // Check if we found a valid publication
      if (program?.id) {
        return {
          ...program,
          seo: {
            ...program.seo,
            title: `Extra's bij: ${program.seo.title}'`,
          },
          social: {
            ...program.social,
            title: `Extra's bij: ${program.social.title}'`,
          },
        }
      } else {
        error({
          context: `Couldn't find program: ${slug}.`,
          message: '(404) Programma niet gevonden',
          severity: 'info',
          statusCode: 404,
        })
        return false
      }
    }
  },
  data () {
    return {
      articles: [],
      extraContent: null,
      hasMoreArticlesAvailable: false,
      skipNrArticles: 3, // The first 3 articles are shown on the homepage and shouldn't be shown here as well
    }
  },
  async fetch() {
    if (!this.id) return
    const {
      data: {
        items: articles = [],
        meta: {
          total = 0,
        } = {},
      } = {},
    } = await this.$api.articles.getAll({
      program: this.id,
      domain: this.$config.preprEnvironmentDomain,
      limit: 6,
      offset: this.articles.length + this.skipNrArticles,
    })
    this.articles.push(...articles)
    this.hasMoreArticlesAvailable = total > this.articles.length + this.skipNrArticles
  },
}
